"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearch = void 0;
// @ts-nocheck
const react_1 = require("react");
const debounce_1 = __importDefault(require("lodash/debounce"));
const useSearch = (initialText) => {
    const [searchText, setSearchText] = react_1.useState(initialText || '');
    const handleSearchText = react_1.useCallback(debounce_1.default((text) => {
        setSearchText(text);
    }, 300), [setSearchText]);
    return { searchText, handleSearchText };
};
exports.useSearch = useSearch;
//# sourceMappingURL=useSearch.js.map